export const routes = (prefix = `theatre`) => [
    {
        path: `/${prefix}/preoperation-notes/print/:patientID`,
        name: `${prefix}.preoperation-notes.print`,
        component: () => import('./PreoperationNotes.vue'),
        meta: {
            requiresAuth: true,
            permissions: {
                PageName: `${prefix}.operation-notes.create`,
                PageDescription: "Theatre: Print operation Notes",
            },
        },
    },
    {
        path: `/${prefix}/anaesthesia-notes/print/:patientID`,
        name: `${prefix}.anaesthesia-notes.print`,
        component: () => import('./AnaesthesiaNotes.vue'),
        meta: {
            requiresAuth: true,
            permissions: {
                PageName: `${prefix}.operation-notes.create`,
                PageDescription: "Theatre: Print operation Notes",
            },
        },
    },
    {
        path: `/${prefix}/operation-notes/print/:patientID`,
        name: `${prefix}.operation-notes.print`,
        component: () => import('./OperationNotes.vue'),
        meta: {
            requiresAuth: true,
            permissions: {
                PageName: `${prefix}.operation-notes.create`,
                PageDescription: "Theatre: Print operation Notes",
            },
        },
    },
    {
        path: `/${prefix}/postoperation-notes/print/:patientID`,
        name: `${prefix}.postoperation-notes.print`,
        component: () => import('./PostOperationNotes.vue'),
        meta: {
            requiresAuth: true,
            permissions: {
                PageName: `${prefix}.operation-notes.create`,
                PageDescription: "Theatre: Print operation Notes",
            },
        },
    },
];
